import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UIExpandableText from 'UIComponents/text/UIExpandableText';
import { CompletionStatuses } from '../../../../../constants';
import { useTracker } from '../../../../../context/hooks';
import { SeoRecommendations } from '../../../../constants';
import { RecommendationBaseView } from '../../../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SubtopicPhrasesList = ({
  subtopicPhrases
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(H7, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.subHeader.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
      })
    }), /*#__PURE__*/_jsx(UIExpandableText, {
      maxHeight: 128,
      children: /*#__PURE__*/_jsx(UIList, {
        className: "m-bottom-0",
        styled: true,
        children: subtopicPhrases.map((phrase, key) => {
          return /*#__PURE__*/_jsx("span", {
            children: phrase
          }, key);
        })
      })
    })]
  });
};
export const IncreaseClusterPhraseInBodyCountView = ({
  auditResult
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    subtopicPhrases
  } = auditResult;
  const showSubtopicPhrases = status === CompletionStatuses.INCOMPLETE && subtopicPhrases;
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
    }),
    status: status,
    children: [showSubtopicPhrases && /*#__PURE__*/_jsx(SubtopicPhrasesList, {
      subtopicPhrases: subtopicPhrases
    }), /*#__PURE__*/_jsx("div", {
      className: "p-left-6 m-top-2",
      children: /*#__PURE__*/_jsx(UILink, {
        href: "https://knowledge.hubspot.com/articles/kcs_article/content-strategy/pillar-pages-topics-and-subtopics#subtopic",
        external: true,
        onClick: handleClickKBLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.linkText.INCREASE_CLUSTER_PHRASE_IN_BODY_COUNT"
        })
      })
    })]
  });
};